import React from 'react'
import PropTypes from "prop-types"
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import { isNumber, values, toString } from 'lodash'
import { Row, Col, Panel, Table, Glyphicon, ButtonGroup } from 'react-bootstrap'
import moment from 'moment'
import queryString from 'query-string'
import DocumentTitle from "react-document-title"
import { printMoney } from 'Lib/Tools.js'
import { calculateItemPriceForOne } from "Lib/TripTools"

import DeleteConfirm from './DeleteConfirm'
import { updateActivity, createActivity, removeActivity } from '../ducks/activities'
import AdminNav from '../components/AdminNav.jsx'
import HoverTip from '../components/HoverTip.jsx'
import { docListStyle } from '../containers/PageStyles'
import Button from '../components/Button.jsx'
import { replaceQuery } from '../lib/AppTools.js'
import { getText, getTextWithTokens, getLocale, getLanguage } from '../lib/text.js'
import TagsFilter from '../tags/TagsFilter'
import ModalTagsEditor from '../tags/ModalTagsEditor'
import TagsList from "../tags/TagsList"
import CityFilter from "./ActivitiesPage.CityFilter"


import {
  getActivities, getDeletedActivities,
  makeGetCityLabel, makeGetCityCountry,
  getFromQuery, getActivityTags,
  getCities, getCitiesByCountry
} from '../selectors'

import "./ActivitiesPage.less"

/* sorting and filtering activities */

function sortActivities(col: string, direction: "ASC"|"DESC"|"NONE", list: Object[]): Object[] {
  return list.sort((a, b) => {
    if (direction === "ASC") {
      const comparison = (toString(a[col]) || " ").localeCompare(toString(b[col]) || "")
      return comparison || (a.name || " ").localeCompare(b.name || " ")
    }
    else if (direction === "DESC") {
      const comparison = (toString(b[col]) || " ").localeCompare(toString(a[col]) || " ")
      return comparison || (a.name || " ").localeCompare(b.name || " ")
    }

    return (a.name || " ").localeCompare(b.name || " ")
  })
}

function filterActivities(country, city, tag, list, Cities) {
  let filtered = list
  if (city && city != "ALL") {
    filtered = list.filter(activity => activity.city == city)
  }
  else if (country && country != "ALL") {
    filtered = list.filter(activity => (Cities[activity.city] && Cities[activity.city].country == country))
  }

  return filtered.filter(activity => (tag === "all" || !tag || activity.tags[tag]))
}

function mangleActivities(activities, cities, country, city, sortColumn, sortDirection, tag) {
  return sortActivities(
    sortColumn,
    sortDirection,
    filterActivities(country, city, tag, activities, cities)
  )
}

/** Activity picker
 * choose an activity, may be edit it
 * as close to stateless as posible
 * activitiesList needs only id, name and city
 * selectedActvity must be the whole document
 */

class ActivitiesPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      editingTags: false, 
      deletingId: null,
    }

    this.boundHandleTag = this.handleTag.bind(this)
    this.boundHandleFilter = this.handleFilter.bind(this)
  }

  open(id) {
    const back = browserHistory.getCurrentLocation().pathname + browserHistory.getCurrentLocation().search
    browserHistory.push(`/private/activity/${encodeURIComponent(id)}?${queryString.stringify({ back })}`)
  }

  handleActivityCreate(city) {
    const n = prompt(getText("Nombre"))
    if (n) this.props.onActivityCreate(n, city, (id) => this.open(id))
  }

  handleSort(sortColumn) {
    if (sortColumn === this.props.query.sortColumn) {
      replaceQuery(browserHistory, this.props.query, {
        sortDirection: this.props.query.sortDirection === "ASC" ? "DESC" : "ASC"
      })
    }
    else {
      replaceQuery(browserHistory, this.props.query, {
        sortColumn,
        sortDirection: (sortColumn === "creation" || sortColumn === "modification" ? "DESC" : "ASC")
      })
    }
  }

  handleFilter(country, city, go = true) {
    replaceQuery(browserHistory, this.props.query, { country, city, go })
  }

  handleTag(tag) {
    replaceQuery(browserHistory, this.props.query, { tag })
  }

  toggleBin() {
    const bin = !this.props.query.bin

    if (this.props.query.sortColumn == "creation" || this.props.query.sortColumn == "deleted") {
      replaceQuery(browserHistory, this.props.query, {
        bin,
        sortColumn: (bin ? "deleted" : "creation")
      })
    }
    else {
      replaceQuery(browserHistory, this.props.query, { bin })
    }
  }

  handleRemoveClick(evt) {
    const target = evt.currentTarget
    if (confirm(getTextWithTokens("delete_activity", [target.getAttribute("data-name")]))) {
      this.props.remove(target.getAttribute("data-id"))
    }
  }

  handleActivityChange(id, k, v) {
    this.props.onUpdate(id, k, v)
  }

  render() {
    const language = getLanguage()
    const { list } = this.props
    const { sortColumn, bin } = this.props.query
    const { citiesByCountry } = this.props

    const backQueryString = queryString.stringify({
      back: browserHistory.getCurrentLocation().pathname + browserHistory.getCurrentLocation().search
    })

    const MyTh = ({ label, col }) => (
      <th
        onClick={() => this.handleSort(col)}
        style={{ textDecoration: sortColumn === col ? "underline" : "none", cursor: "pointer" }}
      >
        <Glyphicon glyph="sort" />{label}
      </th>
    )

    return (
      <div
        style={docListStyle()}
        className="normal activities-page"
      >
        <DocumentTitle title={`Tripmaker ${getText("Actividades")}`} />
        <AdminNav active="activities" />

        {
          bin && (
            <Panel className="floating-bin" bsStyle="danger">
              <Panel.Heading>
                <Panel.Title>
                  <Glyphicon glyph="trash" /> Estás viendo las actividades eliminadas
                </Panel.Title>
              </Panel.Heading>
            </Panel>
          )
        }
        {
          this.state.deletingId && (
            <DeleteConfirm
              onCancel={() => this.setState({ deletingId: null })}
              onConfirm={() => {
                this.props.remove(this.state.deletingId)
                this.setState({ deletingId: null })
              }}
              activityName={this.props.activities[this.state.deletingId].name}
            />
          )
        }
        <div className="toolbar">
          <Button
            glyph="plus"
            className="add"
            onClick={() => this.handleActivityCreate(this.props.query.city ? 
              this.props.query.city == "ALL" ?  citiesByCountry[this.props.query.country][0]._id : this.props.query.city 
              : "Madrid")}
            label={getText("Nueva actividad")}
            bsStyle="success"
          />

          <div className="right">
            {
              this.props.query.go && (
                <React.Fragment>
                  <CityFilter
                    inline
                    onChange={this.boundHandleFilter}
                    selectedCountry={this.props.query.country || "ALL"}
                    selectedCity={this.props.query.city || "ALL"}
                  />
                  <TagsFilter
                    label={null}
                    selectedTag={this.props.query.tag}
                    data={this.props.tags}
                    style={{ marginLeft: 20, marginRight: 5 }}
                    onChange={this.boundHandleTag}
                  />
                  <Button glyph="pencil" onClick={() => this.setState({ editingTags: true })}>
                    Editar etiquetas
                  </Button>
                  {
                    this.state.editingTags && (
                      <ModalTagsEditor
                        tagType="activities"
                        onClose={() => this.setState({ editingTags: false })}
                      />
                    )
                  }
                </React.Fragment>
              )
            }

            <div className={`bin ${bin ? "on" : "off"}`}>
              {
                bin ? (
                  <React.Fragment>
                    <Glyphicon glyph="trash" />
                    <label key="b">Papelera</label>
                    <a key="c" href="#" onClick={() => this.toggleBin()}>
                      <Glyphicon glyph="arrow-left">Volver</Glyphicon>
                    </a>
                  </React.Fragment>
                ) : (
                  <Button glyph="trash" onClick={() => this.toggleBin()}>Ver Papelera</Button>
                )
              }
            </div>
          </div>
        </div>

        {
          !this.props.query.go && (
            <Row>
              <Col md={3} />
              <Col md={6}>
                <CityFilter
                  onChange={(country, city) => (
                    country && city
                      ? this.handleFilter(country, city, true)
                      : this.handleFilter(country, city, false)
                  )}
                  selectedCountry={this.props.query.country}
                  selectedCity={this.props.query.city}
                />
              </Col>
              <Col md={3} />
            </Row>
          )
        }

        {
          this.props.query.go && (
            <React.Fragment>
              <Table bordered striped className={`activities-table ${bin ? "deleted" : ""}`}>
                <thead>
                  <tr>
                    { !bin && <th className="butt" /> }
                    <MyTh col="name" label={getText("Nombre")} />
                    <MyTh col="city" label={getText("Ciudad")} />

                    <th className="price">
                      {getText("Precio")}
                      <HoverTip text="Precio para 1 persona de 30 años">
                        <Glyphicon glyph="question-sign" />
                      </HoverTip>
                    </th>

                    {
                      bin
                        ? <MyTh col="deleted" label={getText("Eliminado")} />
                        : <MyTh col="creation" label={getText("Creación")} />
                    }

                    <MyTh col="modification" label={getText("Modificación")} />
                    <th className="tags">Etiquetas</th>
                    { bin && <th>Recuperar</th> }
                  </tr>
                </thead>
                <tbody>
                  {
                    list.map(activity => (
                      <tr key={activity._id}>
                        {
                          !bin && (
                            <td>
                              <ButtonGroup>
                                <Button
                                  bsSize="xsmall"
                                  style={{ color: "red" }}
                                  glyph="remove"
                                  onClick={() => {
                                    this.setState({ deletingId: activity._id })                                    
                                  }} 
                                />
                              </ButtonGroup>
                            </td>
                          )
                        }
                        <td>
                          <Link to={`/private/activity/${encodeURIComponent(activity._id)}?${backQueryString}`}>
                            {language === "es" ? activity.name : activity.title}
                            <span className="small">
                              ({language === "es" ? activity.title : activity.name})
                            </span>
                          </Link>
                        </td>
                        <td>
                          {(this.props.getCityCountry(activity.city) || { flag: "? " }).flag}
                          {this.props.getCityLabel(activity.city)}
                        </td>
                        <td className="price-cell">
                          { 
                            activity.price.perGroup
                              ? `${printMoney(activity.price.general)}/g`
                              : printMoney(calculateItemPriceForOne(activity.price))
                          }
                        </td>
                        <td>
                          {
                            bin ? (
                              isNumber(activity.deleted)
                                ? moment(new Date(activity.deleted)).locale(getLocale()).fromNow()
                                : "-"
                            ) : (
                              activity.creation
                                ? moment(activity.creation).locale(getLocale()).fromNow()
                                : "-"
                            )
                          }
                        </td>
                        <td>{activity.modification ? moment(activity.modification).locale(getLocale()).fromNow() : "-"}</td>
                        <td>
                          <TagsList
                            allTags={this.props.tags}
                            selectedTags={activity.tags}
                            onChange={tags => this.props.onUpdate(activity._id, { tags })}
                            onClick={tagId => this.handleTag(tagId)}
                            tagType="activities"
                          />
                        </td>
                        {
                          bin && (
                            <td>
                              <ButtonGroup>
                                <Button
                                  bsSize="xsmall"
                                  style={{ color: "green" }}
                                  glyph="ok"
                                  onClick={() => {
                                    this.props.onUpdate(activity._id, { deleted: null })                                    
                                  }} 
                                />
                              </ButtonGroup>
                            </td>
                          )
                        }
                      </tr>
                    ))
                  }
                </tbody>
              </Table>

              <i>(Se muestran {list.length} actividades)</i>
            </React.Fragment>
          )
        }

      </div>
    )
  }
}

ActivitiesPage.propTypes = {
  activities: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired, // (string, string, any) => void,
  onActivityCreate: PropTypes.func.isRequired, // (string, string => void) => void,
  remove: PropTypes.func.isRequired,
  getCityCountry: PropTypes.func.isRequired, // string => string,
  getCityLabel: PropTypes.func.isRequired, // string => string,
  tags: PropTypes.objectOf(PropTypes.bool).isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  citiesByCountry: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.object)).isRequired,

  query: PropTypes.shape({
    country: PropTypes.string,
    city: PropTypes.string,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.oneOf([ "ASC", "DESC" ]),
    tag: PropTypes.string,
    bin: PropTypes.bool,
    go: PropTypes.bool,
  }).isRequired
}

/**
 *
 */

const mapStateToProps = (state, props) => {
  const query = {
    country: getFromQuery(state, props)("country") || null,
    city: getFromQuery(state, props)("city") || null,
    sortDirection: getFromQuery(state, props)("sortDirection") || "DESC",
    sortColumn: getFromQuery(state, props)("sortColumn") || "modification",
    tag: getFromQuery(state, props)("tag") || "all",
    bin: getFromQuery(state, props)("bin") == "true",
    go: getFromQuery(state, props)("go") == "true",
  }

  const activities = query.bin ? getDeletedActivities(state, props) : getActivities(state, props)
  const cities = getCities(state, props)
  const getCityLabel = makeGetCityLabel(state, props)
  const getCityCountry = makeGetCityCountry(state, props)
  const tags = getActivityTags(state, props)
  const citiesByCountry = getCitiesByCountry(state, props)

  const list = query.go
    ? mangleActivities(
      values(activities),
      cities,
      query.country,
      query.city,
      query.sortColumn,
      query.sortDirection,
      query.tag
    )
    : []

  return {
    activities, getCityLabel, getCityCountry, tags, query, list, citiesByCountry
  }
}

const mapDispatchToProps = (dispatch) => ({
  onUpdate: (id, change) => dispatch(updateActivity(id, change)),
  onActivityCreate: (name, city, idCallback) => dispatch(createActivity({ name, city }, idCallback)),
  remove: id => dispatch(removeActivity(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesPage)
